import { Alert, Button, Stack, Typography } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router';
import { Foutmelding, Laden } from '../componenten/Laadstatus.tsx';
import { Aanmeldkader } from './AanmeldPagina.tsx';
import { useSessie } from './SessieContext.tsx';

/**
 * Laat de onderliggende routes alleen zien aan een aangemelde, goedgekeurde gebruiker. Anders gaat de
 * gebruiker naar de aanmeldpagina, of ziet hij dat zijn account nog op goedkeuring wacht.
 * @returns De onderliggende route, of de juiste melding.
 */
export function VereistAanmelding() {
  const { ik, laden, fout, herlaad, meldAf } = useSessie();
  const locatie = useLocation();

  if (laden) {
    return <Laden hoogte={400} />;
  }
  if (fout) {
    return (
      <Aanmeldkader>
        <Foutmelding fout={fout} opnieuw={() => void herlaad()} />
      </Aanmeldkader>
    );
  }
  if (!ik) {
    // Na een mislukte aanmelding stuurt de API terug met ?fout=<code>; die moet de aanmeldpagina tonen.
    const fout = new URLSearchParams(locatie.search).get('fout');
    return (
      <Navigate
        to={fout ? `/aanmelden?fout=${encodeURIComponent(fout)}` : '/aanmelden'}
        replace
        state={{ van: fout ? '/' : `${locatie.pathname}${locatie.search}` }}
      />
    );
  }
  if (ik.gebruiker.status !== 'actief') {
    return (
      <Aanmeldkader>
        <Stack spacing={2}>
          {ik.gebruiker.status === 'in_afwachting' ? (
            <Alert severity="info">
              Je account wacht op goedkeuring door een beheerder. Probeer het later opnieuw.
            </Alert>
          ) : (
            <Alert severity="warning">Je account is gedeactiveerd.</Alert>
          )}
          <Typography color="text.secondary">Aangemeld als {ik.gebruiker.email}.</Typography>
          <Button variant="outlined" onClick={() => void meldAf()}>
            Afmelden
          </Button>
        </Stack>
      </Aanmeldkader>
    );
  }
  return <Outlet />;
}
